module.exports = __webpack_public_path__ + "img/flag.9401a051.png";